export default "/images/logo_pergamum_vertical.png?977ed48137558a5c551cb0767d7bef20";